module.exports = __webpack_public_path__ + "static/media/canon-d60-dslr-2.646d606f.jpg";